import React, { useState, useEffect } from 'react';
import { showAppAlert } from '../utils/alertService';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function AddAnnotationModal({ client, visible, onClose }) {
  const [annotation, setAnnotation] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) {
      setAnnotation('');
    }
  }, [visible]);

  if (!visible || !client) {
    return null;
  }

  const handleSave = async () => {
    if (!annotation.trim()) {
      showAppAlert('warning', 'A anotação não pode estar vazia.');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user'));

      const response = await fetch(`${API_URL}/clients/annotations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          client_id: client.id,
          user_id: user.id,
          annotation: annotation,
        }),
      });

      const data = await response.json();

      if (response.status === 201) {
        showAppAlert('success', data.message || 'Anotação salva com sucesso!');
        onClose();
      } else {
        showAppAlert('error', data.message || 'Erro ao salvar a anotação.');
      }
    } catch (error) {
      console.error('Erro ao salvar anotação:', error);
      showAppAlert('error', 'Ocorreu um erro de rede. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: 500 }}>
        <h3>Adicionar Anotação para {client.nome}</h3>
        <textarea
          value={annotation}
          onChange={(e) => setAnnotation(e.target.value)}
          placeholder="Digite sua anotação aqui..."
          className="input-style"
          style={{ width: '100%', minHeight: '150px', margin: '20px 0' }}
        />
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="button-style cancel" onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button className="button-style" onClick={handleSave} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddAnnotationModal;